import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'line-dashed', 'LineDashed', [["path",{"d":"M5 12h2"}],["path",{"d":"M17 12h2"}],["path",{"d":"M11 12h2"}]]);